import iconOne from '../../assets/symptoms/modclaire.webp';
import iconTwo from '../../assets/features/philips.webp';
import iconThree from '../../assets/features/dmg.webp';
import iconFour from '../../assets/features/biolase.webp';

const PartnerData = [
    {
        icon: iconOne,
        key: 'claire'
    },
    {
        icon: iconTwo,
        key: 'philips'
    },
    {
        icon: iconThree,
        key: 'dmg'
    },
    {
        icon: iconFour,
        key: 'biolase'
    }
];

export default PartnerData;